module.exports = __webpack_public_path__ + "img/icon_robot.971a3b84.png";